// locationOrder.js
// ONE definition of "which clinic comes first", used by every view.
//
// The backend's `locations` list (DataService.data["locations"], delivered on
// every schedule payload as schedule.locations) is the user-defined display
// order — set in Clinical Operations via the reorder (pencil) mode and
// persisted with PUT /api/locations/order. No view may re-sort clinics
// alphabetically; they all sort with `compareLocations(schedule)` so the
// roster, the console, the ward bands and the exports agree.
//
// Locations are compared by ID (Oct 2026). Unknown keys (a location no longer
// in the list, an on-call pseudo-location)
// sort AFTER every known one, alphabetically, so nothing ever disappears.

export const locationRank = (schedule) => {
  const order = (schedule && (schedule.locations || [])) || [];
  const rank = new Map();
  order.forEach((name, i) => rank.set(String(name), i));
  return rank;
};

/** Comparator over location IDS honouring the user-defined order. */
export const compareLocations = (schedule) => {
  const rank = locationRank(schedule);
  const n = rank.size;
  return (a, b) => {
    const ra = rank.has(String(a)) ? rank.get(String(a)) : n;
    const rb = rank.has(String(b)) ? rank.get(String(b)) : n;
    return ra - rb || String(a).localeCompare(String(b));
  };
};

/** Return a new array of location ids sorted into the user-defined order. */
export const sortLocations = (names, schedule) => [...(names || [])].sort(compareLocations(schedule));
